import { AfterContentChecked, AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { fromEvent, pairwise, Subscription, switchMap, takeUntil } from 'rxjs';
import { LoggerService } from '../providers/logger.service';
import { TwfstyleService } from '../providers/twfstyle.service';

@Component({
  selector: 'app-text',
  template: `
<div #abxElementWrapper><span #fakeWSpan id='fake-w-span' [ngStyle]='element.cssStyle' class='transparent abx-donot-dragndrop'>{{ element.text }}</span>
<input #inputTextBox [ngStyle]='element.cssStyle' style="background-color: transparent" [ngClass]="(element.selected ? 'selected-element' : '')" [ngModel]='element.text' (input)="changeText($event)" (keydown.enter)="handleEnterKey($event)" type='text' class='abx-element abx-element-text abx-donot-dragndrop'>
<span #letterSpacingController id='letter-spacing-controller' class='letter-spacing-controller abx-donot-dragndrop' [ngClass]="(element.selected ? '' : 'selected-element-hide')" [ngStyle]='cssLetterSpacingController'></span></div>
  `,
  styles: [
  ]
})
export class TextComponent implements OnInit, AfterViewInit, OnChanges {
  prevText = '';

  @ViewChild('fakeWSpan') fakeWSpan: ElementRef<HTMLSpanElement>;
  @ViewChild('inputTextBox') input: ElementRef<HTMLInputElement>;
  @ViewChild('letterSpacingController') letterSpacingController: ElementRef<HTMLSpanElement>;
  @ViewChild("abxElementWrapper", { static: false }) abxElementWrapper: ElementRef;

  cssStyleSpan = {};
  cssLetterSpacingController: any = { display: 'none' };
  inputWidthInPx = 0;
  cssStyle: any;

  letterSpacingControllerMoving = false;
  letterSpacingControllerInitMouseX = 0;
  letterSpacingControllerInitSpacing = 0;

  isLetterSpacingControllerPressed: boolean = false;

  @Input() draggable: boolean;
  @Input() scale: any;
  @Input() element: any;
  @Input() pageModifiedPosition: boolean;
  @Input() pageModified: boolean;
  @Input() selected: boolean = false;
  @Input() selectedTextIsNew: boolean;

  @Output() onLetterSpacingChangeStart: EventEmitter<any> = new EventEmitter();
  @Output() onLetterSpacingChange: EventEmitter<any> = new EventEmitter();
  @Output() onLetterSpacingChangeEnd: EventEmitter<any> = new EventEmitter();
  @Output() onTextChanged: EventEmitter<any> = new EventEmitter();
  @Output() onEnter: EventEmitter<any> = new EventEmitter();
  @Output() pageModifiedReset: EventEmitter<boolean> = new EventEmitter();
  constructor(
    private elementRef: ElementRef,
    private twfStyle: TwfstyleService,
    private logger: LoggerService,
    private cdref: ChangeDetectorRef)
  { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    //this.abxElementWrapper.nativeElement.addEventListener('pointerdown', (e) => {
    //  this.isMouseDown = true;
    //  if ((e.touches && e.touches[0].target && e.touches[0].target['id'] === 'letter-spacing-controller') || (e.target && e.target.id === 'letter-spacing-controller')) {
    //    this.handleLetterSpacingControllerMouseDown(e);
    //  }
    //}, { passive: false });
    //
    //this.abxElementWrapper.nativeElement.addEventListener('touchstart', (e) => {
    //
    //  this.isMouseDown = true;
    //  if ((e.touches && e.touches[0].target && e.touches[0].target['id'] === 'letter-spacing-controller')) {
    //    this.handleLetterSpacingControllerMouseDown(e);
    //  }
    //}, { passive: false });
    //
    //this.abxElementWrapper.nativeElement.addEventListener('pointermove', (e) => {
    //
    //  if (this.isLetterSpacingControllerPressed) {
    //    this.handleLetterSpacingControllerMouseMove(e);
    //  } else {
    //    if (this.isMouseDown) {
    //      let el = this.element;
    //
    //      el.cssStyle = {
    //        position: 'absolute',
    //        left: el.x + 'px',
    //        top: el.y + 'px',
    //        fontSize: el.size + 'px',
    //        color: el.cssColor,
    //        fontFamily: el.cssFont,
    //        fontWeight: el.cssFontWeight,
    //        fontStyle: el.cssFontStyle,
    //        whiteSpace: 'pre',
    //        outline: 'none',
    //        padding: '0px',
    //        letterSpacing: el.letterSpacing + 'px',
    //        border: 'none'
    //      };
    //    }
    //  }
    //}, { passive: false });
    //
    //this.abxElementWrapper.nativeElement.addEventListener('touchmove', (e) => {
    //
    //  if (this.isLetterSpacingControllerPressed) {
    //    this.handleLetterSpacingControllerMouseMove(e);
    //  } else {
    //    if (this.isMouseDown) {
    //      let el = this.element;
    //
    //      el.cssStyle = {
    //        position: 'absolute',
    //        left: el.x + 'px',
    //        top: el.y + 'px',
    //        fontSize: el.size + 'px',
    //        color: el.cssColor,
    //        fontFamily: el.cssFont,
    //        fontWeight: el.cssFontWeight,
    //        fontStyle: el.cssFontStyle,
    //        whiteSpace: 'pre',
    //        outline: 'none',
    //        padding: '0px',
    //        letterSpacing: el.letterSpacing + 'px',
    //        border: 'none'
    //      };
    //    }
    //  }
    //}, { passive: false });
    //
    //this.abxElementWrapper.nativeElement.addEventListener('pointerup', (e) => {
    //  this.isMouseDown = false;
    //  if (this.isLetterSpacingControllerPressed) {
    //    this.handleLetterSpacingControllerMouseUp(e);
    //  }
    //}, { passive: false });
    //this.fakeWSpan = document.getElementById('fake-w-span');
    //this.letterSpacingController = document.getElementById('letter-spacing-controller');
    //this.input = this.elementRef.nativeElement.querySelector('input');

    this.drawText(this.element, self);
    this.prevText = this.element.text;
    setTimeout(() => { this.sanitize() }, 50);
  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    try {
      if (this.element.selected === true) {
        await this.drawText(this.element, self);
        this.pageModifiedReset.emit(false);
        this.cdref.detectChanges();
      }
    } catch (e) {
      this.logger.logInternalError("TextComponent: $onChanges", e.message);
    }
  }

  handleLetterSpacingControllerMouseDown(ev) {
    //if (this.element.selected === true && (this.fakeWSpan && ((ev.target && ev.target.id === 'letter-spacing-controller') || (ev.touches && ev.touches[0].target && ev.touches[0].target.id === 'letter-spacing-controller')))) {
      this.isLetterSpacingControllerPressed = true
      this.letterSpacingControllerInitSpacing = this.element.letterSpacing;
      this.letterSpacingControllerInitMouseX = ev.clientX ? ev.clientX : ev.touches[0].clientX;
      this.letterSpacingControllerMoving = true;
      this.onLetterSpacingChangeStart.emit();

    //ev.preventDefault();
    //ev.stopPropagation();
    //}
  }

  handleLetterSpacingControllerMouseMove(ev) {
    if (!this.letterSpacingControllerMoving || this.element.text.length < 2 || this.element.selected !== true)
      return;

    var currentX = ev.clientX ? ev.clientX : ev.touches[0].clientX;
    var deltaW = (currentX - this.letterSpacingControllerInitMouseX) / this.scale;

    var newSpacing = this.letterSpacingControllerInitSpacing + (deltaW / (this.element.text.length - 1));
    if (newSpacing < 2)
      newSpacing = 2;

    this.element.letterSpacing = newSpacing;
    this.onLetterSpacingChange.emit();

    //ev.preventDefault();
    ev.stopPropagation();
  }

  handleLetterSpacingControllerMouseUp(ev) {
    this.isLetterSpacingControllerPressed = false;
    if (!this.letterSpacingControllerMoving || this.element.selected !== true)
      return;

    this.letterSpacingControllerMoving = false;
    this.onLetterSpacingChangeEnd.emit();
    //ev.preventDefault();
    ev.stopPropagation();
  }

  drawText(el, self) {
    try {
      if (!self)
        return;

      el.cssColor = this.twfStyle.toCssColor(el.color);
      el.cssFont = this.twfStyle.toCssFont(el.font);
      el.cssFontWeight = this.twfStyle.toCssFontWeight(el.bold);
      el.cssFontStyle = this.twfStyle.toCssFontStyle(el.italic);

      el.cssStyle = {
        position: 'absolute',
        left: el.x + 'px',
        top: el.y + 'px',
        fontSize: el.size + 'px',
        color: el.cssColor,
        fontFamily: el.cssFont,
        fontWeight: el.cssFontWeight,
        fontStyle: el.cssFontStyle,
        whiteSpace: 'pre',
        outline: 'none',
        padding: '0px',
        letterSpacing: el.letterSpacing + 'px',
        border: 'none'
      };

      
      this.sanitize();
      this.cdref.detectChanges();

      if (el.text != this.prevText) {
        this.onTextChanged.emit();
        this.prevText = el.text;
      }

    } catch (e) {
      this.logger.logInternalError("TEXT: draw", e.message);
    }
  }

  setLetterPositionControllerStyle() {
    try {

      this.cssLetterSpacingController = {
        display: (this.element.selected && this.element.letterSpacing > 0 && this.element.text.length >= 2 ? 'inline-block' : 'none'),
        left: (this.inputWidthInPx === 0 ? this.element.x + (this.element.size * 2.5) + 'px' : this.element.x + this.inputWidthInPx + 'px'),
        top: this.element.y + (this.element.size * 0.2) + 'px',
        height: this.element.size + 'px',
        width: this.element.size + 'px'
      }

    } catch (e) {
      this.logger.logInternalError("TEXT: setLetterPositionControllerStyle", e.message);
    }
  }

  handleEnterKey(e) {
    this.sanitize();

    if (e.keyCode === 13) {
      e.preventDefault();
      this.onEnter.emit();
      //$scope.$apply => { this.onEnter(); });
      return false;
    }

    return true;
  }

  sanitize() {
    if (this.fakeWSpan && this.input) {

      var w = this.fakeWSpan.nativeElement.offsetWidth + this.fakeWSpan.nativeElement.offsetHeight;

      if (w === 0 || w === 19) {
        this.input.nativeElement.style.width = '2em';
        this.inputWidthInPx = 0;
      }
      else {
        this.input.nativeElement.style.width = w + 'px';
        this.inputWidthInPx = w;
      }

      this.setLetterPositionControllerStyle();
    }
  }

  changeText(ev: any = undefined) {
    this.element.text = ev.target.value;
    this.sanitize();
  }

  isMouseDown: boolean = false;
  @HostListener('window:pointerup', ['$event'])
  onMouseUp(event) {
    this.isMouseDown = false;
  
    if (this.isLetterSpacingControllerPressed) {
      this.handleLetterSpacingControllerMouseUp(event);
    }
  }

  @HostListener('window:pointerdown', ['$event'])
  onMouseDown(event) {
    this.isMouseDown = true;
    const ev = event;
    if ((ev.target && ev.target.id === 'letter-spacing-controller')) {
      this.handleLetterSpacingControllerMouseDown(event);
    }
  }

  @HostListener('window:pointermove', ['$event'])
  onMouseMove(event) {
    if (this.isLetterSpacingControllerPressed) {
      this.handleLetterSpacingControllerMouseMove(event);
    } else {
      if (this.isMouseDown) {
        let el = this.element;

        el.cssStyle = {
          position: 'absolute',
          left: el.x + 'px',
          top: el.y + 'px',
          fontSize: el.size + 'px',
          color: el.cssColor,
          fontFamily: el.cssFont,
          fontWeight: el.cssFontWeight,
          fontStyle: el.cssFontStyle,
          whiteSpace: 'pre',
          outline: 'none',
          padding: '0px',
          letterSpacing: el.letterSpacing + 'px',
          border: 'none'
        };
      }
    }    
  }

  @HostListener('document:touchstart', ['$event'])
  pressTouchEventHandler(e: TouchEvent) {
    this.isMouseDown = true;
    if ((e.touches && e.touches[0].target && e.touches[0].target['id'] === 'letter-spacing-controller')) {
      this.handleLetterSpacingControllerMouseDown(e);
    }
  }

  @HostListener('document:touchmove', ['$event'])
  touchDragEventHandler(event: TouchEvent) {
    if (this.isLetterSpacingControllerPressed) {
      this.handleLetterSpacingControllerMouseMove(event);
    } else {
      if (this.isMouseDown) {
        let el = this.element;

        el.cssStyle = {
          position: 'absolute',
          left: el.x + 'px',
          top: el.y + 'px',
          fontSize: el.size + 'px',
          color: el.cssColor,
          fontFamily: el.cssFont,
          fontWeight: el.cssFontWeight,
          fontStyle: el.cssFontStyle,
          whiteSpace: 'pre',
          outline: 'none',
          padding: '0px',
          letterSpacing: el.letterSpacing + 'px',
          border: 'none'
        };
      }
    } 
  }

  @HostListener('document:touchend', ['$event'])
  touchReleaseEventHandler(event: TouchEvent) {
    this.isMouseDown = false;
    if (this.isLetterSpacingControllerPressed) {
      this.handleLetterSpacingControllerMouseUp(event);
    }
  }

  @HostListener('document:touchout', ['$event'])
  touchOutEventHandler(event: TouchEvent) {
    this.isMouseDown = false;
    if (this.isLetterSpacingControllerPressed) {
      this.handleLetterSpacingControllerMouseUp(event);
    }
  }
}
